<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'Become a Distributor'"></navbar>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<div class="msg_box">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Diagnostics That<br />
						Meet Timelines.<br />
						In More Ways Than One.
					</div>
					<div class="tit"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Become a CorDx Distributor for POC or OTC Markets
					</div>
					<div class="txt"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="500"
						data-aos-offset="0"
						data-aos-once="true"
					>
						CorDx tests deliver rapid results – and we deliver your order under clear terms and honest timelines.
						Fulfill your customer orders with diagnostics you can count on.
					</div>
					<div
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="1000"
						data-aos-offset="0"
						data-aos-once="true"
					class="btn_box btn_el" style="" @click="goForm">
						Become A Distributor<img src="../../assets/img/icon_w.webp" />
					</div>
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="img_box">
					<div class="img_el"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img class="img1" src="../../assets/become-a-distributor/block_1.webp" />
					</div>
					<div class="img_el"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img class="img2" src="../../assets/become-a-distributor/block_2.webp" />
					</div>
					<div class="img_el"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img class="img3" src="../../assets/become-a-distributor/block_3.webp" />
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="msg_box">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Deliver Diagnostics for Any Season of Life<br />
						(Including Peak Season)
					</div>
					<div class="text"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						CorDx manufactures a full range of rapid health tests that your customers need to stock. When peak cold & flu season strikes, we have the 
						capacity to make sure you meet the spike in demand.
					</div>
					<div class="list_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="list_el">
							<div class="tit">18+</div>
							<div class="txt">Years of Experience</div>
						</div>
						<div class="list_el">
							<div class="tit">1000+</div>
							<div class="txt">Innovative Products</div>
						</div>
						<div class="list_el">
							<div class="tit">700+</div>
							<div class="txt">Global Partners</div>
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div class="block_1_el">
					<div class="img_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/become-a-distributor/block_4.webp" />
					</div>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">
							End-to-End <span>Sales Support</span>
						</div>
						<div class="text">
							From retail to e-commerce to field sales, you get a dedicated, expert account manager providing key resources, including hands-on training and supply chain support, to ensure your customers' success.
						</div>
					</div>
				</div>
				<div class="block_1_el">
					<div class="img_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/become-a-distributor/block_5.webp" />
					</div>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">
							Transparent <span>Collaboration</span>
						</div>
						<div class="text">
							CorDx has already figured out capacity, quality control, packing, and other logistical hurdles. Since we own our supply chain, there are no gaps that could keep us from getting our products exactly where you need them. Honest timelines and clear terms allow you to work confidently, knowing your investment is safe, and your customer relationships are reinforced. 
						</div>
					</div>
				</div>
				<div class="block_1_el">
					<div class="img_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/become-a-distributor/block_6.webp" />
					</div>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">
							Competitive <span>Pricing</span>
						</div>
						<div class="text">
							Customizable quantities and specifications allow you to adapt your business's strategy to a rapidly changing industry and your customer's business. Capitalize on volume discounts that meet the pricing needs of your customers and sales channel requirements.
						</div>
					</div>
				</div>
				<div class="btn_main"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="btn_box btn_el" style="" @click="goForm">
						BECOME A CORDX DISTRIBUTOR<img src="../../assets/img/icon_w.webp" style="top: 12px;" />
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4">
				<div class="msg_box">
					<div class="text"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						CorDx manufactures point-of-care and over-the-counter rapid diagnostic products across a variety of categories, including infectious disease, reproductive & sexual health, substance abuse, and other health and marker tests. With authorization for use in the US (FDA), Europe (CE Mark) and China (NMPA), CorDx tests are known for their comfort, speed and accuracy.
					</div>
					<div class="text" style="padding-top: 20px;"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Since 2006, CorDx has developed diagnostic products while establishing a solid supply chain foundation, allowing it to provide better quality, more affordable tests for distributors, healthcare providers and patients alike.
					</div>
				</div>
			</div>
			<!--块4-->
			<!--块5-->
			<div class="block_5">
				<div class="msg_box">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						A Pathway for Accessible Diagnostics
					</div>
					<div class="text"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Ensure your customers have the diagnostics they need when they need them.
					</div>
					<div class="btn_main"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="btn_box btn_el" style="" @click="goForm">
							BECOME A CORDX DISTRIBUTOR<img src="../../assets/img/icon_w.webp" style="top: 12px;" />
						</div>
					</div>
				</div>
			</div>
			<!--块5-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
import contact from '@/component/contact.vue'  //联系我们
export default {
	components:{
		navbar,
		footerBox,
		fixed,
		contact,
	},
	data() {
		return {
			isLoading: true,  //界面loading
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		document.title = 'Become a Distributor - CorDx';
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		goForm() {
			let that = this;
			window.location.href = 'https://9503031.extforms.netsuite.com/app/site/crm/externalleadpage.nl?compid=9503031&formid=23&h=AAFdikaIH6WUqW1yW9kZZ3iAhIX-MXs0ttg70TbK45nYOzsDrho';
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	color: #000000;
	//块5
	.block_5{
		padding: 70px 20px;
		background: linear-gradient( 180deg, rgba(255,255,255,0) 0%, #F1ECE6 100%);
		.msg_box{
			width: 100%;
			text-align: center;
			.btn_main{
				text-align: center;
				.btn_el{
					height: 50px;
					line-height: 50px;
					margin-top: 40px;
					background-color: #F26F32;
					color: #ffffff;
					border: none;
					font-size: 20px;
					padding-top: 2px;
					border-radius: 46px;
				}
			}
			.text{
				padding-top: 20px;
				font-size: 18px;
				color: #0B318F;
			}
			.title{
				font-size: 30px;
			}
		}
	}
	//块4
	.block_4{
		padding: 40px 20px;
		background-color: #F2F7FC;
		.msg_box{
			width: 100%;
			.text{
				font-size: 18px;
			}
		}
	}
	//块3
	.block_3{
		width: 100%;
		position: relative;
		padding: 0px 20px 100px 20px;
		.btn_main{
			text-align: center;
			.btn_el{
				height: 50px;
				line-height: 50px;
				margin-top: 40px;
				background-color: #F26F32;
				color: #ffffff;
				border: none;
				font-size: 20px;
				padding-top: 2px;
				border-radius: 46px;
			}
		}
		.block_1_el{
			width: 100%;
			padding-top: 50px;
			.msg_box{
				flex: 1;
				.text{
					padding-top: 12px;
					font-size: 18px;
				}
				.title{
					padding-top: 30px;
					font-size: 28px;
					span{
						font-size: 28px;
						color: #FF6600;
					}
				}
			}
			.img_box{
				width: 100%;
				img{
					width: 100%;
				}
			}
		}
	}
	//块2
	.block_2{
		padding: 70px 0 20px 0;
		.msg_box{
			width: 100%;
			text-align: center;
			padding: 0 20px;
			.list_box{
				.list_el{
					padding-top: 40px;
					.txt{
						padding-top: 0px;
						font-size: 20px;
						color: #0B318F;
					}
					.tit{
						font-size: 48px;
						color: #0B318F;
						line-height: 1;
					}
				}
			}
			.text{
				padding-top: 20px;
				font-size: 18px;
			}
			.title{
				font-size: 30px;
				color: #0B318F;
			}
		}
	}
	//块1
	.block_1{
		padding: 10px 0 60px 0;
		background-color: #F2F7FC;
		.img_box{
			width: 100%;
			.img_el{
				width: auto;
				padding-top: 50px;
				text-align: center;
				.img3{
					width: 295px;
				}
				.img2{
					width: 165px;
				}
				.img1{
					width: 195px;
				}
			}
		}
	}
	//banner
	.banner_box{
		position: relative;
		padding: 70px 20px;
		background-color: #0B318F;
		text-align: center;
		.msg_box{
			width: 100%;
			.btn_el{
				margin-top: 35px;
				color: #ffffff;
				background-color: #F26F32;
				border: 1px solid #F26F32;
			}
			.txt{
				padding-top: 20px;
				font-size: 18px;
				color: #ffffff;
			}
			.tit{
				padding-top: 20px;
				color: #F26F32;
				font-size: 18px;
			}
			.title{
				font-size: 36px;
				font-weight: bold;
				line-height: 1.2;
				color: #ffffff;
			}
		}
	}
	.btn_box{
		display: inline-block;
		padding: 0px 28px 0 28px;
		height: 40px;
		line-height: 40px;
		font-size: 18px;
		color: #ffffff;
		background: transparent;
		border-radius: 37px;
		border: 1px solid #ffffff;
		text-align: center;
		cursor: pointer;
		img{
			width: 20px !important;
			min-width: 20px !important;
			position: relative;
			top: 8px;
			left: 10px;
			transition: all 0.3s;
		}
	}
}
</style>
